/* eslint-disable class-methods-use-this */
// Optimizely — a consent-gated analytics snippet. It previously lived in
// `src/utilities/analytics-snippets.js`; it now plugs into the shared
// third-party snippet system as the reference example of a snippet that only
// loads after Osano analytics consent is granted. Adding another consent-gated
// analytics script is just another subclass like this one.
import { ThirdPartySnippet, TRIGGERS, injectScript } from './snippet';

export const OPTIMIZELY_ID = 'optimizely-snippet';
export const OPTIMIZELY_SRC = 'https://cdn.optimizely.com/js/25473630273.js';

export class OptimizelySnippet extends ThirdPartySnippet {
  constructor() {
    super({
      id: OPTIMIZELY_ID,
      // Only loads once Osano ANALYTICS consent is ACCEPT.
      consentCategory: 'ANALYTICS',
      triggers: [TRIGGERS.CONSENT]
    });
  }

  load() {
    injectScript({ id: OPTIMIZELY_ID, src: OPTIMIZELY_SRC });
  }
}

const optimizelySnippet = new OptimizelySnippet();

export default optimizelySnippet;
